module.exports = __webpack_public_path__ + "static/media/generic.a5f0fcad.svg";